// extracted by mini-css-extract-plugin
export default {"root":"styles_root__IuMkf","settingsBody":"styles_settingsBody__Okz6B"};